import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useOrderReceiving = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("usePaymethodcontext---------", context.useApiError);
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useOrderReceiving-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useOrderReceiving-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useOrderReceiving-error-${orderId}`);

  // 确认收货
  const orderReceiving = async (orderId) => {
    try {
      loading.value = true;
      result.value = null;
      const customQuery = {
        order_id: orderId
      };
      // console.log("pay参数---------", customQuery);
      const res = await context.$xbuy.api.orderReceiving(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else {
        error.value = res.message;
        setError({ code: res.code, message: res.message });
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    orderReceiving,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
